export const highlightMatchingText = ({
    text,
    matchText,
    className = 'bg-yellow-500 text-regular font-bold',
}: {
    text: string
    matchText: string
    className?: string
}) => {
    if (!matchText.trim()) return text

    const trimmedMatchText = matchText.trim()
    const lowerText = text.toLowerCase().trim()
    const lowerMatchText = trimmedMatchText.toLowerCase()

    const startIndex = lowerText.indexOf(lowerMatchText)
    const endIndex = startIndex + trimmedMatchText.length

    if (startIndex === -1) {
        // If no match is found, return the original text
        return text
    }

    const textStart = text.slice(0, startIndex).toString()
    const textEnd = text.slice(endIndex).toString()

    return (
        <>
            {textStart}
            <span className={className}>
                {text.slice(startIndex, endIndex)}
            </span>
            {textEnd}
        </>
    )
}
